import { get } from '@/axios'

export interface ICheckRewardsNoReceivedRequest {
  completed_period: number
  completed_times: number
  trigger_event: string
}

export interface ICheckRewardsNoReceivedResponse {
  no_received_task: boolean
  no_received_task_daily: boolean
  no_received_task_weekly: boolean
}

export const checkRewardsNoReceived = async () => {
  const response = await get<ICheckRewardsNoReceivedResponse>(`/taskApi/userTask/checkRewardsNoReceived`, null, {
    'Cache-Control': 'no-cache',
  })

  return response
}
